import log, { type LogLevelDesc } from 'loglevel'
import logPrefixPlugin from 'loglevel-plugin-prefix'

export function setupRootLogger(level: LogLevelDesc = 'debug') {
  log.setLevel(level)
  logPrefixPlugin.reg(log)
  logPrefixPlugin.apply(log)
}
